import api from "./axios-http";

// Change Password
export const changePassword = async (passwordData) => {
  try {
    const response = await api.patch("/api/auth/change-password", passwordData);
    return response.data;
  } catch (error) {
    throw error;
  }
};

// Verify Two-Factor Authentication
export const verifyTwoFactor = async (twoFactorData) => {
  try {
    const response = await api.post("/api/auth/verify-2fa", twoFactorData);
    return response.data;
  } catch (error) {
    throw error;
  }
};

// Login
export const login = async (loginData) => {
  try {
    const response = await api.post("/api/auth/login", loginData);
    return response.data;
  } catch (error) {
    throw error;
  }
};

// Forgot Password
export const forgotPassword = async (emailData) => {
  try {
    const response = await api.post("/api/auth/forgot-password", emailData);
    return response.data;
  } catch (error) {
    throw error;
  }
};

// List Contacts (paginated with filters)
export const listContacts = async (params = {}) => {
  try {
    const { page = 0, size = 20, status, search, archived = false } = params;
    const response = await api.get("/api/contacts", {
      params: { page, size, status, search, archived }
    });
    return response.data;
  } catch (error) {
    throw error;
  }
};

// Get Contact by ID
export const getContactById = async (id) => {
  try {
    const response = await api.get(`/api/contacts/${id}`);
    return response.data;
  } catch (error) {
    throw error;
  }
};

// Create Contact
export const createContact = async (contactData) => {
  try {
    const response = await api.post("/api/contacts", contactData);
    return response.data;
  } catch (error) {
    throw error;
  }
};

// Update Contact (full update)
export const updateContact = async (id, contactData) => {
  try {
    const response = await api.put(`/api/contacts/${id}`, contactData);
    return response.data;
  } catch (error) {
    throw error;
  }
};

// Update Contact Status
export const updateContactStatus = async (id, status) => {
  try {
    const response = await api.patch(`/api/contacts/${id}/status`, null, {
      params: { status }
    });
    return response.data;
  } catch (error) {
    throw error;
  }
};

// Delete Contact
export const deleteContact = async (id) => {
  try {
    const response = await api.delete(`/api/contacts/${id}`);
    return response.data;
  } catch (error) {
    throw error;
  }
};

// Get Contact Status Stats
export const getContactStats = async () => {
  try {
    const response = await api.get("/api/contacts/stats");
    return response.data;
  } catch (error) {
    throw error;
  }
};
// List Deals (paginated with filters)
export const listDeals = async (params = {}) => {
  try {
    const { page = 0, size = 20, stage, search } = params;
    const response = await api.get("/api/deals", {
      params: { page, size, stage, search }
    });
    return response.data;
  } catch (error) {
    throw error;
  }
};

// Get Deal by ID
export const getDealById = async (id) => {
  try {
    const response = await api.get(`/api/deals/${id}`);
    return response.data;
  } catch (error) {
    throw error;
  }
};

// Create Deal
export const createDeal = async (dealData) => {
  try {
    const response = await api.post("/api/deals", dealData);
    return response.data;
  } catch (error) {
    throw error;
  }
};

// Update Deal
export const updateDeal = async (id, dealData) => {
  try {
    const response = await api.put(`/api/deals/${id}`, dealData);
    return response.data;
  } catch (error) {
    throw error;
  }
};

// Delete Deal
export const deleteDeal = async (id) => {
  try {
    const response = await api.delete(`/api/deals/${id}`);
    return response.data;
  } catch (error) {
    throw error;
  }
};

// Update Deal Stage (for Kanban drag-and-drop)
export const updateDealStage = async (id, stage) => {
  try {
    const response = await api.patch(`/api/deals/${id}/stage`, null, {
      params: { stage }
    });
    return response.data;
  } catch (error) {
    throw error;
  }
};

// Get Kanban View (all deals ordered by stage)
export const getKanbanDeals = async () => {
  try {
    const response = await api.get("/api/deals/kanban");
    return response.data;
  } catch (error) {
    throw error;
  }
};

// Get Pipeline Statistics (count and value per stage)
export const getPipelineStats = async () => {
  try {
    const response = await api.get("/api/deals/pipeline-stats");
    return response.data;
  } catch (error) {
    throw error;
  }
};
// List Interactions (paginated with type filter)
export const listInteractions = async (params = {}) => {
  try {
    const { page = 0, size = 20, type } = params;
    const response = await api.get("/api/interactions", {
      params: { page, size, type }
    });
    return response.data;
  } catch (error) {
    throw error;
  }
};

// Get Interaction by ID
export const getInteractionById = async (id) => {
  try {
    const response = await api.get(`/api/interactions/${id}`);
    return response.data;
  } catch (error) {
    throw error;
  }
};

// Log Interaction (Create)
export const logInteraction = async (interactionData) => {
  try {
    const response = await api.post("/api/interactions", interactionData);
    return response.data;
  } catch (error) {
    throw error;
  }
};

// Update Interaction
export const updateInteraction = async (id, interactionData) => {
  try {
    const response = await api.put(`/api/interactions/${id}`, interactionData);
    return response.data;
  } catch (error) {
    throw error;
  }
};

// Delete Interaction
export const deleteInteraction = async (id) => {
  try {
    const response = await api.delete(`/api/interactions/${id}`);
    return response.data;
  } catch (error) {
    throw error;
  }
};

// Get Monthly Interaction Stats
export const getMonthlyInteractionStats = async () => {
  try {
    const response = await api.get("/api/interactions/stats/monthly");
    return response.data;
  } catch (error) {
    throw error;
  }
};

// Get Interactions by Contact
export const getInteractionsByContact = async (contactId) => {
  try {
    const response = await api.get(`/api/interactions/by-contact/${contactId}`);
    return response.data;
  } catch (error) {
    throw error;
  }
};

// List Tasks (paginated with status or priority filter)
export const listTasks = async (params = {}) => {
  try {
    const { page = 0, size = 20, status, priority } = params;
    const response = await api.get("/api/tasks", {
      params: { page, size, status, priority }
    });
    return response.data;
  } catch (error) {
    throw error;
  }
};

// Get Task by ID
export const getTaskById = async (id) => {
  try {
    const response = await api.get(`/api/tasks/${id}`);
    return response.data;
  } catch (error) {
    throw error;
  }
};

// Create Task
export const createTask = async (taskData) => {
  try {
    const response = await api.post("/api/tasks", taskData);
    return response.data;
  } catch (error) {
    throw error;
  }
};

// Update Task
export const updateTask = async (id, taskData) => {
  try {
    const response = await api.put(`/api/tasks/${id}`, taskData);
    return response.data;
  } catch (error) {
    throw error;
  }
};

// Delete Task
export const deleteTask = async (id) => {
  try {
    const response = await api.delete(`/api/tasks/${id}`);
    return response.data;
  } catch (error) {
    throw error;
  }
};

// Mark Task Status (quick status toggle)
export const updateTaskStatus = async (id, status) => {
  try {
    const response = await api.patch(`/api/tasks/${id}/status`, null, {
      params: { status }
    });
    return response.data;
  } catch (error) {
    throw error;
  }
};

// Get Today's Tasks (for Dashboard widget)
export const getTodaysTasks = async () => {
  try {
    const response = await api.get("/api/tasks/today");
    return response.data;
  } catch (error) {
    throw error;
  }
};

// Get Task Stats (counts per status + overdue count)
export const getTaskStats = async () => {
  try {
    const response = await api.get("/api/tasks/stats");
    return response.data;
  } catch (error) {
    throw error;
  }
};

// Get Overdue Tasks
export const getOverdueTasks = async () => {
  try {
    const response = await api.get("/api/tasks/overdue");
    return response.data;
  } catch (error) {
    throw error;
  }
};

// Get Tasks by Deal
export const getTasksByDeal = async (dealId) => {
  try {
    const response = await api.get(`/api/tasks/by-deal/${dealId}`);
    return response.data;
  } catch (error) {
    throw error;
  }
};

// Get Tasks by Contact
export const getTasksByContact = async (contactId) => {
  try {
    const response = await api.get(`/api/tasks/by-contact/${contactId}`);
    return response.data;
  } catch (error) {
    throw error;
  }
};
export const getTasksByUser = async (userId) => {
  try {
    const response = await api.get(`/api/tasks/by-user/${userId}`);
    return response.data;
  } catch (error) {
    throw error;
  }
};


// ==================== User Management ====================

// List All Users (paginated)
export const listUsers = async (params = {}) => {
  try {
    const { page = 0, size = 20 } = params;
    const response = await api.get("/api/admin/users", {
      params: { page, size }
    });
    return response.data;
  } catch (error) {
    throw error;
  }
};

// Get User Details + Performance
export const getUserDetails = async (id) => {
  try {
    const response = await api.get(`/api/admin/users/${id}`);
    return response.data;
  } catch (error) {
    throw error;
  }
};

// Create User Account
export const createUser = async (userData) => {
  try {
    const response = await api.post("/api/admin/users", userData);
    return response.data;
  } catch (error) {
    throw error;
  }
};

// Update User
export const updateUser = async (id, userData) => {
  try {
    const response = await api.put(`/api/admin/users/${id}`, userData);
    return response.data;
  } catch (error) {
    throw error;
  }
};

// Delete User
export const deleteUser = async (id) => {
  try {
    const response = await api.delete(`/api/admin/users/${id}`);
    return response.data;
  } catch (error) {
    throw error;
  }
};

// Enable Account
export const enableUserAccount = async (id) => {
  try {
    const response = await api.patch(`/api/admin/users/${id}/enable`);
    return response.data;
  } catch (error) {
    throw error;
  }
};

// Disable Account
export const disableUserAccount = async (id) => {
  try {
    const response = await api.patch(`/api/admin/users/${id}/disable`);
    return response.data;
  } catch (error) {
    throw error;
  }
};

// Reset Password (generate and email new password)
export const resetUserPassword = async (id) => {
  try {
    const response = await api.post(`/api/admin/users/${id}/reset-password`);
    return response.data;
  } catch (error) {
    throw error;
  }
};

// ==================== Performance & Analytics ====================

// Get User Performance Metrics
export const getUserPerformance = async (id) => {
  try {
    const response = await api.get(`/api/admin/users/${id}/performance`);
    return response.data;
  } catch (error) {
    throw error;
  }
};

// Get Global Performance (System-wide KPIs)
export const getGlobalPerformance = async () => {
  try {
    const response = await api.get("/api/admin/performance");
    return response.data;
  } catch (error) {
    throw error;
  }
};

// ==================== Audit Logs ====================

// Get User Audit Logs
export const getUserAuditLogs = async (id, params = {}) => {
  try {
    const { page = 0, size = 50 } = params;
    const response = await api.get(`/api/admin/users/${id}/audit-logs`, {
      params: { page, size }
    });
    return response.data;
  } catch (error) {
    throw error;
  }
};

// Get All Audit Logs
export const getAllAuditLogs = async (params = {}) => {
  try {
    const { page = 0, size = 50 } = params;
    const response = await api.get("/api/admin/audit-logs", {
      params: { page, size }
    });
    return response.data;
  } catch (error) {
    throw error;
  }
};
// Get Dashboard Data
export const getDashboardData = async () => {
  try {
    const response = await api.get("/api/dashboard");
    return response.data;
  } catch (error) {
    throw error;
  }
};


export const closeDeal = async (id, closeData) => {
  try {
    const response = await api.patch(`/api/deals/${id}/close`, closeData);
    return response.data;
  } catch (error) {
    throw error;
  }
};

// Get Pipeline Kanban View (contacts ordered by pipeline stage with nested deals)
export const getContactsKanban = async () => {
  try {
    const response = await api.get("/api/contacts/kanban");
    return response.data;
  } catch (error) {
    throw error;
  }
};

// Get Deals for Contact
export const getDealsByContact = async (contactId) => {
  try {
    const response = await api.get(`/api/contacts/${contactId}/deals`);
    return response.data;
  } catch (error) {
    throw error;
  }
};

// Move Contact Stage (drag-and-drop on Kanban board)
export const updateContactStage = async (contactId, stage) => {
  try {
    const response = await api.patch(`/api/contacts/${contactId}/stage`, null, {
      params: { stage }
    });
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const getNotifications = async (params = {}) => {
  const { page = 0, size = 20 } = params;
  const response = await api.get("/api/notifications", { params: { page, size } });
  return response.data;
};
export const getUnreadCount = async () => {
  const response = await api.get("/api/notifications/unread-count");
  return response.data;
};
export const markNotificationRead = async (id) => {
  const response = await api.patch(`/api/notifications/${id}/read`);
  return response.data;
};
export const markAllNotificationsRead = async () => {
  const response = await api.patch("/api/notifications/read-all");
  return response.data;
};
export const deleteNotification = async (id) => {
  const response = await api.delete(`/api/notifications/${id}`);
  return response.data;
};

export const getContactPersons = async ({ contactId, search = "" } = {}) => {
  try {
    const response = await api.get(`/api/contacts/${contactId}/persons`, {
      params: { search }
    });
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const getContactPersonById = async ({ contactId, personId }) => {
  try {
    const response = await api.get(`/api/contacts/${contactId}/persons/${personId}`);
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const addContactPerson = async ({
  contactId,
  firstName,
  lastName,
  email,
  phone,
  mobile,
  jobTitle,
  department,
  linkedIn,
  avatarUrl,
  primaryContact,
  notes
}) => {
  try {
    const response = await api.post(`/api/contacts/${contactId}/persons`, {
      firstName,
      lastName,
      email,
      phone,
      mobile,
      jobTitle,
      department,
      linkedIn,
      avatarUrl,
      primaryContact,
      notes
    });
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const updateContactPerson = async ({
  contactId,
  personId,
  firstName,
  lastName,
  email,
  phone,
  mobile,
  jobTitle,
  department,
  linkedIn,
  avatarUrl,
  primaryContact,
  notes
}) => {
  try {
    const response = await api.put(`/api/contacts/${contactId}/persons/${personId}`, {
      firstName,
      lastName,
      email,
      phone,
      mobile,
      jobTitle,
      department,
      linkedIn,
      avatarUrl,
      primaryContact,
      notes
    });
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const deleteContactPerson = async ({ contactId, personId }) => {
  try {
    const response = await api.delete(`/api/contacts/${contactId}/persons/${personId}`);
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const setPrimaryContactPerson = async ({ contactId, personId }) => {
  try {
    const response = await api.patch(`/api/contacts/${contactId}/persons/${personId}/primary`);
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const updateContactQualification = async ({ id, decision, note }) => {
  try {
    const response = await api.patch(`/api/contacts/${id}/qualification`, {
      decision,
      note
    });
    return response.data;
  } catch (error) {
    throw error;
  }
};
// ============ CONTACTS ARCHIVE ============
// PATCH /api/contacts/{id}/archive
export const archiveContact = async ({ id, reason }) => {
  try {
    const response = await api.patch(`/api/contacts/${id}/archive`, { reason });
    return response.data;
  } catch (error) {
    throw error;
  }
};

// PATCH /api/contacts/{id}/unarchive
export const unarchiveContact = async ({ id }) => {
  try {
    const response = await api.patch(`/api/contacts/${id}/unarchive`);
    return response.data;
  } catch (error) {
    throw error;
  }
};

// ============ INTERACTIONS ============
// GET /api/interactions/{id}/attachment
export const downloadInteractionAttachment = async ({ id }) => {
  try {
    const response = await api.get(`/api/interactions/${id}/attachment`, {
      responseType: "blob",
    });
    return response.data;
  } catch (error) {
    throw error;
  }
};

// GET /api/interactions/{id}/recording
export const playInteractionRecording = async ({ id }) => {
  try {
    const response = await api.get(`/api/interactions/${id}/recording`, {
      responseType: "blob",
    });
    return response.data;
  } catch (error) {
    throw error;
  }
};

// POST /api/interactions/email  (multipart, flat fields)
export const sendEmailInteraction = async ({ contactId, to, cc, bcc, subject, body, attachment }) => {
  try {
    const formData = new FormData();
    formData.append("contactId", contactId);
    formData.append("to", to);
    if (cc) formData.append("cc", cc);
    if (bcc) formData.append("bcc", bcc);
    formData.append("subject", subject);
    formData.append("body", body);
    if (attachment) formData.append("attachment", attachment);

    const response = await api.post("/api/interactions/email", formData, {
      headers: { "Content-Type": "multipart/form-data" },
    });
    return response.data;
  } catch (error) {
    throw error;
  }
};

// POST /api/interactions  (multipart, call with audio)
export const logInteractionWithRecording = async ({
  type, subject, contactId, dealId, notes, durationMinutes,
  primaryPhone, secondaryPhone, recording, recordingDurationSeconds, occurredAt,
}) => {
  try {
    const formData = new FormData();
    formData.append("type", type);
    formData.append("contactId", contactId);
    formData.append("subject", subject);
    formData.append("occurredAt", occurredAt);
    if (dealId) formData.append("dealId", dealId);
    if (notes) formData.append("notes", notes);
    if (durationMinutes !== null && durationMinutes !== undefined && durationMinutes !== "") {
      formData.append("durationMinutes", String(durationMinutes));
    }
    if (primaryPhone) formData.append("primaryPhone", primaryPhone);
    if (secondaryPhone) formData.append("secondaryPhone", secondaryPhone);

    if (recording) {
      const mime = recording.type || "";
      const ext = mime.includes("mp4") ? "mp4" : mime.includes("ogg") ? "ogg" : "webm";
      formData.append("recording", recording, `call.${ext}`);
      if (recordingDurationSeconds !== null && recordingDurationSeconds !== undefined) {
        formData.append("recordingDurationSeconds", String(recordingDurationSeconds));
      }
    }

    const response = await api.post("/api/interactions", formData, {
      headers: { "Content-Type": "multipart/form-data" },
    });
    return response.data;
  } catch (error) {
    throw error;
  }
};